import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Import necessari per SEO e Navigazione
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

// --- BLOCCO FORZATURA TEMA CHIARO ---
// Questo script viene eseguito prima di renderizzare l'app
if (typeof document !== 'undefined') {
  // Rimuove la classe 'dark' se presente
  document.documentElement.classList.remove('dark');
  // Aggiunge la classe 'light'
  document.documentElement.classList.add('light');
  // Imposta lo stile color-scheme
  document.documentElement.style.colorScheme = 'light';
}
// ------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();